import React from 'react';
import { Card } from 'antd'; 
import { Link } from '@nackle/biw-web-router';
import classNames from 'classnames';
import './styles.less';

export const PageLinkCard = ( { href, icon, description, disabled, title } ) => {
 
    return    <Link 
            disabled={ disabled }
            className="page-link-card-wrapper" 
            to={ disabled ? undefined : href }
        >
            <CardContent icon={ icon } title={ title } description={ description } disabled={ disabled } />
        </Link>;
};

const CardContent = ( { icon, title, description, disabled = false } ) => {
    return <Card
        className={ classNames( 'page-link-card', { disabled } ) }
        hoverable={ !disabled }
        cover={
            <div className="page-link-card-cover-content">
                <span className="page-link-card-icon">
                    { icon }
                </span>
            </div>
        }
    >
        <Card.Meta
            title={ title }
            description={ description }
        />
        { disabled && <div className='disable-mask' /> }
    </Card>;
};